import { type GridCellProps } from '@progress/kendo-react-grid'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { userRoleNameToLabel } from '../constants'
import { type BrandAccountUser } from '../hooks'

export type CommandsCellProps = Omit<GridCellProps, 'dataItem'> & {
  dataItem: BrandAccountUser
}

export const RoleCell: React.FC<CommandsCellProps> = ({ dataItem }) => {
  const { t } = useTranslation()

  const roleName = dataItem.role?.name
  const translatedRole = roleName ? t(userRoleNameToLabel[roleName]) : ''

  return <td>{translatedRole}</td>
}
